// removed by extract-text-webpack-plugin
module.exports = {"overlay":"_1Bexs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadingOverlay/LoadingOverlay.scss
// module id = ./src/components/LoadingOverlay/LoadingOverlay.scss
// module chunks = 4